import { UPDATE_OKR_STATUS } from "../actionTypes";

const initialState = {
  isAccess: false,
};

const getOkrStatus = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_OKR_STATUS:
      return {
        ...state,
        isAccess: action.payload.isAccess,
      };
    default:
      break;
  }

  return state;
};

export default getOkrStatus;
